import { fetchConversation } from 'modules/conference/actions/fetchConversation';
import { onDecline } from 'modules/conference/actions/_newConversationActions/onDecline';
import { currentConversation } from 'modules/appointmentInfo/selectors/currentAppointment';
import { stopConsultationAfterWSResponse } from 'modules/conference/actions/stopConsultation';
import { onIncomingCall } from 'modules/conference/actions/_newConversationActions/onIncomingCall';
import { onUnanswerParticipant } from 'modules/conference/actions/_newConversationActions/onUnunsweredCall';

import {
  IN_PROGRESS,
  PENDING,
  DECLINED,
  DISCONNECTED,
  UNANSWERED,
  ENDED,
  CREATED,
  DROPPED,
  endedConversationStatuses,
} from 'modules/common/constants/conversationStatuses';

import createAction from '../';


export const WS_UPDATE_CONVERSATION = createAction('WS_UPDATE_CONVERSATION');

export const onConversationUpdate = ({ err, data }) => (dispatch, getState) => {
  if (err) throw new Error(err);

  const state = getState();

  const currentConversationStatus = currentConversation(state).status;
  const { conversationUpdate } = data;
  const { conversationId, appointmentId, conversationStatus, updatedAt } = conversationUpdate;

  if (![...endedConversationStatuses, CREATED].includes(conversationStatus)
    && (updatedAt < currentConversation(state).updatedAt || !currentConversation(state).updatedAt)) {
    return;
  }

  if (conversationStatus !== CREATED) {
    dispatch({
      type: WS_UPDATE_CONVERSATION,
      payload: { conversationUpdate },
    });
  }

  switch (conversationStatus) {
    case CREATED:
      if (/RnUmmanu/.test(navigator.userAgent)) return null;

      return dispatch(onIncomingCall({ conversationId, appointmentId }));
    case UNANSWERED:
      return dispatch(onUnanswerParticipant(conversationStatus));
    case DECLINED:
      return dispatch(onDecline());
    case DISCONNECTED:
    case DROPPED:
    case ENDED:
      return dispatch(stopConsultationAfterWSResponse(conversationStatus));
    case IN_PROGRESS:
      if (currentConversationStatus === PENDING) dispatch(fetchConversation(conversationId));
      break;
    default:
      return null;
  }
};
